<app-breadcrumb [title]="curentLang === 'en' ? 'Company Info' : (curentLang === 'ar' ? ' معلومات المصلحة التجارية  ' : '  פרטי חברה  ')" 
[items]="curentLang === 'en' ? ['Dashboard'] : (curentLang === 'ar' ? ['لوحة التحكم'] : ['הגדרות'])" 
[active_item]="curentLang === 'en' ? 'Company Info' : (curentLang === 'ar' ? ' معلومات المصلحة التجارية  ' : '  פרטי חברה  ')">
</app-breadcrumb>

<div class="container-fluid update-company-page pb-4">
  <!-- Match add-company modal header (same UX as companies → Add) -->
  <div class="card border-0 shadow-sm mb-4 uc-editor-shell">
    <div class="company-modal-header uc-edit-page-header border-bottom">
      <div class="d-flex flex-wrap align-items-start justify-content-between gap-3 w-100">
        <div class="flex-grow-1" style="min-width: 220px;">
          <div class="company-modal-eyebrow">
            {{ curentLang === 'en' ? 'Company setup' : (curentLang === 'ar' ? 'إعداد المصلحة التجارية' : 'הגדרת חברה') }}
          </div>
          <h6 class="company-modal-title mb-1">
            {{ curentLang === 'en' ? 'Edit company' : (curentLang === 'ar' ? 'تعديل المصلحة التجارية' : 'עריכת חברה') }}
          </h6>
          <p class="company-modal-subtitle mb-0">
            {{ curentLang === 'en' ? 'Update the same structured sections as when adding a company: basics, address, branding, invoice notes, and translations.' : (curentLang === 'ar' ? 'حدّث المصلحة التجارية بنفس أقسام إضافة مصلحة تجارية: الأساسيات، العنوان، الهوية، ملاحظات الفاتورة، والترجمات.' : 'עדכן את החברה באותן מקטעים כמו בהוספה: בסיס, כתובת, מיתוג, הערות חשבונית ותרגומים.') }}
          </p>
        </div>
        <a routerLink="/dashboard/companies" class="btn company-btn-secondary text-nowrap align-self-start">
          <i class="fa fa-arrow-left me-1"></i>
          {{ curentLang === 'en' ? 'Back to list' : (curentLang === 'ar' ? 'العودة للقائمة' : 'חזרה לרשימה') }}
        </a>
      </div>
    </div>
  </div>

  <div class="company-modal-body uc-edit-body px-0 pb-4">

  <!-- Merchant: single FormGroup across sidebar + main -->
  <div class="row g-4" *ngIf="user_type == 100 || user_type == 101" [formGroup]="updateCompanyInfo">
    <div class="col-xl-4 d-flex flex-column gap-3">
      <section class="company-form-section add-company-prototype">
        <div class="add-co-section-head">
          <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Images' : (curentLang === 'ar' ? 'الصور' : 'תמונות') }}</span>
        </div>
        <div class="add-co-upload-grid">
          <div class="add-co-upload-box uc-brand-upload" [class.has-image]="companyInfoData.logo_url"
               (click)="executeFunctions(companyInfoData?.company_id, uploadData)" role="button" tabindex="0">
            <div class="uc-brand-upload-inner">
              <img class="uc-brand-thumb" alt=""
                   [src]="companyInfoData.logo_url ? companyInfoData.logo_url : 'assets/default-logo/WhatsApp Image 2024-07-09 at 21.30.21_fc2afcbb.jpg'" />
              <div class="add-co-upload-icon uc-brand-cam"><i class="fa fa-camera"></i></div>
            </div>
            <div class="add-co-upload-label">{{ curentLang === 'en' ? 'Company logo' : (curentLang === 'ar' ? 'شعار المصلحة التجارية' : 'לוגו חברה') }}</div>
            <div class="add-co-upload-hint">{{ curentLang === 'en' ? 'Tap to change' : (curentLang === 'ar' ? 'اضغط للتغيير' : 'לחץ לשינוי') }}</div>
            <button type="button" class="add-co-remove-file mt-1" (click)="$event.stopPropagation(); getId(companyInfoData?.company_id); openVerticallyCentered(dataDeleted)">
              {{ curentLang === 'en' ? 'Remove logo' : (curentLang === 'ar' ? 'حذف الشعار' : 'מחק לוגו') }}
            </button>
          </div>
          <div class="add-co-upload-box uc-brand-upload" [class.has-image]="companyInfoData.seal_url"
               (click)="executeFunctionsSignatureModal(companyInfoData?.company_id, uploadSignature)" role="button" tabindex="0">
            <div class="uc-brand-upload-inner">
              <img class="uc-brand-thumb" alt=""
                   [src]="companyInfoData.seal_url ? companyInfoData.seal_url : 'assets/default-logo/WhatsApp Image 2024-07-09 at 21.30.21_fc2afcbb.jpg'" />
              <div class="add-co-upload-icon uc-brand-cam"><i class="fa fa-camera"></i></div>
            </div>
            <div class="add-co-upload-label">{{ curentLang === 'en' ? 'Seal / signature' : (curentLang === 'ar' ? 'التوقيع / الختم' : 'חתימה / חותמת') }}</div>
            <div class="add-co-upload-hint">{{ curentLang === 'en' ? 'Tap to change' : (curentLang === 'ar' ? 'اضغط للتغيير' : 'לחץ לשינוי') }}</div>
          </div>
        </div>
      </section>

      <section class="company-form-section add-company-prototype">
        <div class="add-co-section-head">
          <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Invoice appearance' : (curentLang === 'ar' ? 'مظهر الفاتورة' : 'מראה חשבונית') }}</span>
        </div>
        <div class="uc-template-thumb mb-3" (click)="openTemplateModal(templateModal)" role="button" tabindex="0">
          <img class="rounded w-100" style="max-height: 200px; object-fit: contain;" alt="Template"
               [src]="selectedTemplate?.template_url" />
        </div>
        <label class="form-label">{{ curentLang === 'en' ? 'Template' : (curentLang === 'ar' ? 'القالب' : 'תבנית') }}</label>
        <div *ngFor="let template of templates" class="form-check mb-1">
          <input type="radio" class="form-check-input" [id]="'tpl_m_' + template.id"
                 [value]="template.id" formControlName="template_id"
                 (change)="onTemplateChange(template.id)"
                 [checked]="template.id === updateCompanyInfo.get('template_id')?.value" />
          <label class="form-check-label custom-radio-label" [for]="'tpl_m_' + template.id"
                 [ngClass]="{'fw-semibold text-dark': updateCompanyInfo.get('template_id')?.value === template.id}">
            {{ curentLang === 'en' ? template.name_en : (curentLang === 'ar' ? template.name_ar : template.name_he) }}
          </label>
        </div>
        <div class="add-co-divider"></div>
        <div class="add-co-notes-grid row">
          <div class="mb-3 col-md-6">
            <div class="add-co-notes-col-title"><span class="add-co-dot add-co-dot-dark"></span>{{ curentLang === 'en' ? 'Right column note' : (curentLang === 'ar' ? 'ملاحظات يمين' : 'הערות ימין') }}</div>
            <textarea class="form-control add-co-input-optional" rows="3" maxlength="200" formControlName="right_note"
              [placeholder]="curentLang === 'en' ? 'e.g. Payment within 30 days.' : (curentLang === 'ar' ? 'مثال: الدفع خلال 30 يوماً.' : 'לדוגמה: תשלום בתוך 30 יום.')"
              [class.is-invalid]="updateCompanyInfo.get('right_note')?.invalid && updateCompanyInfo.get('right_note')?.touched"></textarea>
            <small class="text-muted d-block mt-1">{{ curentLang === 'en' ? 'Maximum 200 characters.' : (curentLang === 'ar' ? 'حد أقصى 200 حرفاً.' : 'עד 200 תווים.') }}</small>
          </div>
          <div class="mb-3 col-md-6">
            <div class="add-co-notes-col-title"><span class="add-co-dot add-co-dot-muted"></span>{{ curentLang === 'en' ? 'Left column note' : (curentLang === 'ar' ? 'ملاحظات يسار' : 'הערות שמאל') }}</div>
            <textarea class="form-control add-co-input-optional" rows="3" maxlength="200" formControlName="left_note"
              [placeholder]="curentLang === 'en' ? 'e.g. IBAN: IL00-0000-0000' : (curentLang === 'ar' ? 'مثال: IBAN: IL00-0000-0000' : 'לדוגמה: IBAN: IL00-0000-0000')"
              [class.is-invalid]="updateCompanyInfo.get('left_note')?.invalid && updateCompanyInfo.get('left_note')?.touched"></textarea>
            <small class="text-muted d-block mt-1">{{ curentLang === 'en' ? 'Maximum 200 characters.' : (curentLang === 'ar' ? 'حد أقصى 200 حرفاً.' : 'עד 200 תווים.') }}</small>
          </div>
        </div>
        <div class="add-co-invoice-preview-strip">
          <div class="add-co-preview-side" [class.empty]="!(updateCompanyInfo.get('right_note')?.value || '').toString().trim()">
            {{ (updateCompanyInfo.get('right_note')?.value || '').toString().trim() || (curentLang === 'en' ? 'Right note…' : (curentLang === 'ar' ? 'ملاحظات يمين...' : 'הערות ימין...')) }}
          </div>
          <div class="add-co-preview-center">{{ curentLang === 'en' ? '— Invoice preview —' : (curentLang === 'ar' ? '— معاينة الفاتورة —' : '— תצוגת חשבונית —') }}</div>
          <div class="add-co-preview-side" [class.empty]="!(updateCompanyInfo.get('left_note')?.value || '').toString().trim()">
            {{ (updateCompanyInfo.get('left_note')?.value || '').toString().trim() || (curentLang === 'en' ? 'Left note…' : (curentLang === 'ar' ? 'ملاحظات يسار...' : 'הערות שמאל...')) }}
          </div>
        </div>
      </section>
    </div>

    <div class="col-xl-8">
      <div class="card uc-main-card border-0 shadow-sm h-100">
        <div class="card-body">
          <div class="company-form-shell add-company-prototype" novalidate [ngClass]="{ 'was-validated': validateMerchant }">
            <section class="company-form-section">
              <div class="add-co-section-head">
                <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Basic details' : (curentLang === 'ar' ? 'البيانات الأساسية' : 'פרטים בסיסיים') }}</span>
                <span class="add-co-req-hint">{{ curentLang === 'en' ? '* Required field' : (curentLang === 'ar' ? '* حقل إلزامي' : '* שדה חובה') }}</span>
              </div>
              <div class="row">
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Company name (Hebrew)' : (curentLang === 'ar' ? 'اسم المصلحة التجارية (عبري)' : 'שם החברה (עברית)') }}<span class="text-danger">*</span></label>
                  <input class="form-control" onlyAlphabets required type="text" formControlName="company_name_he" [(ngModel)]="companyNamehE"
                    [placeholder]="curentLang === 'en' ? 'e.g. ABC Ltd.' : (curentLang === 'ar' ? 'مثال: مصلحة تجارية ABC المحدودة' : 'לדוגמה: חברת ABC בע״מ')" />
                  <div *ngIf="updateCompanyInfo.get('company_name_he')?.invalid && updateCompanyInfo.get('company_name_he')?.touched" class="text-danger small mt-1">
                    {{ curentLang === 'en' ? 'Please enter company name' : (curentLang === 'ar' ? 'الرجاء إدخال اسم المصلحة التجارية' : 'נא להזין את שם החברה') }}
                  </div>
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Company type' : (curentLang === 'ar' ? 'نوع المصلحة التجارية' : 'סוג חברה') }}<span class="text-danger">*</span></label>
                  <ng-select formControlName="company_type_id" [searchable]="false" (change)="onCompanyTypeChange($event)"
                    [placeholder]="curentLang === 'en' ? 'Choose type…' : (curentLang === 'ar' ? 'اختر النوع…' : 'בחר סוג…')">
                    <ng-option *ngFor="let item of companyTypeData" [value]="item.company_type_id">
                      {{ curentLang === 'en' ? item.type_name_en : (curentLang === 'ar' ? item.type_name_ar : item.type_name_he) }}
                    </ng-option>
                  </ng-select>
                  <div *ngIf="updateCompanyInfo.get('company_type_id')?.errors?.required && updateCompanyInfo.get('company_type_id')?.touched" class="text-danger small mt-1">
                    {{ curentLang === 'en' ? 'Please choose company type' : (curentLang === 'ar' ? 'الرجاء اختيار نوع المصلحة التجارية' : 'אנא בחר סוג חברה') }}
                  </div>
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Phone' : (curentLang === 'ar' ? 'الهاتف' : 'טלפון') }}
                    <span class="text-muted fw-normal small">{{ curentLang === 'en' ? '(optional)' : (curentLang === 'ar' ? '(اختياري)' : '(אופציונלי)') }}</span></label>
                  <input class="form-control add-co-input-optional" type="tel" formControlName="company_phone" [(ngModel)]="companyPhone" placeholder="05X-XXXXXXX" />
                </div>
              </div>
            </section>

            <div class="add-co-divider"></div>

            <section class="company-form-section">
              <div class="add-co-section-head">
                <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Address' : (curentLang === 'ar' ? 'العنوان' : 'כתובת') }}</span>
              </div>
              <div class="row">
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'City (Hebrew)' : (curentLang === 'ar' ? 'المدينة (عبري)' : 'עיר (עברית)') }}<span class="text-danger">*</span></label>
                  <input class="form-control" type="text" formControlName="company_address_city" [(ngModel)]="CompanyAddressCity" maxlength="100"
                    [placeholder]="curentLang === 'en' ? 'Tel Aviv' : (curentLang === 'ar' ? 'تل أبيب' : 'תל אביב')" />
                  <div *ngIf="updateCompanyInfo.get('company_address_city')?.invalid && updateCompanyInfo.get('company_address_city')?.touched" class="text-danger small mt-1">
                    {{ curentLang === 'en' ? 'Please enter city' : (curentLang === 'ar' ? 'الرجاء إدخال المدينة' : 'נא להזין עיר') }}
                  </div>
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Street (Hebrew)' : (curentLang === 'ar' ? 'اسم الشارع (عبري)' : 'שם רחוב (עברית)') }}<span class="text-danger">*</span></label>
                  <input class="form-control" type="text" formControlName="company_address_str" [(ngModel)]="CompanyAddressSTR" maxlength="100"
                    [placeholder]="curentLang === 'en' ? 'Herzl St.' : (curentLang === 'ar' ? 'شارع هرتسل' : 'רחוב הרצל')" />
                  <div *ngIf="updateCompanyInfo.get('company_address_str')?.invalid && updateCompanyInfo.get('company_address_str')?.touched" class="text-danger small mt-1">
                    {{ curentLang === 'en' ? 'Please enter street' : (curentLang === 'ar' ? 'الرجاء إدخال الشارع' : 'נא להזין רחוב') }}
                  </div>
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Building no.' : (curentLang === 'ar' ? 'رقم المبنى' : 'מספר בניין') }}<span class="text-danger">*</span></label>
                  <input class="form-control" type="number" formControlName="company_Building_number" [(ngModel)]="CompanyBuildingNumber" />
                  <div *ngIf="updateCompanyInfo.get('company_Building_number')?.invalid && updateCompanyInfo.get('company_Building_number')?.touched" class="text-danger small mt-1">
                    {{ curentLang === 'en' ? 'Please enter building number' : (curentLang === 'ar' ? 'الرجاء إدخال رقم المبنى' : 'נא להזין מספר בניין') }}
                  </div>
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Postal code' : (curentLang === 'ar' ? 'الرمز البريدي' : 'מיקוד') }}
                    <span class="text-muted fw-normal small">{{ curentLang === 'en' ? '(optional)' : (curentLang === 'ar' ? '(اختياري)' : '(אופציונלי)') }}</span></label>
                  <input class="form-control add-co-input-optional" type="text" formControlName="company_address_zip_code" [(ngModel)]="CompanyAddressZipCode" placeholder="6100000" />
                </div>
              </div>
            </section>

            <div class="add-co-divider"></div>

            <section class="company-form-section">
              <div class="add-co-section-head">
                <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Translations' : (curentLang === 'ar' ? 'الترجمات' : 'תרגומים') }}</span>
              </div>

              <div *ngIf="translationAddon.ar" class="add-co-lang-block">
                <div class="add-co-lang-block-head">
                  <span><span class="me-1">🇸🇦</span>عربي</span>
                  <button type="button" class="add-co-btn-remove-lang" (click)="removeTranslationLang('ar')">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف' : 'הסר') }} ✕</button>
                </div>
                <div class="row">
                  <div class="mb-3 col-md-6">
                    <label class="form-label">{{ curentLang === 'en' ? 'Company name (Arabic)' : (curentLang === 'ar' ? 'اسم المصلحة التجارية (عربي)' : 'שם החברה (ערבית)') }}</label>
                    <input class="form-control" type="text" formControlName="company_name_ar" [(ngModel)]="companyNameAr" placeholder="مثال: مصلحة تجارية ABC المحدودة" />
                  </div>
                  <div class="mb-3 col-md-6">
                    <label class="form-label">{{ curentLang === 'en' ? 'City (Arabic)' : (curentLang === 'ar' ? 'المدينة (عربي)' : 'עיר (ערבית)') }}</label>
                    <input class="form-control" type="text" formControlName="company_address_city_ar" [(ngModel)]="CompanyAddressCityAr" maxlength="100" />
                  </div>
                  <div class="mb-3 col-12">
                    <label class="form-label">{{ curentLang === 'en' ? 'Street (Arabic)' : (curentLang === 'ar' ? 'اسم الشارع (عربي)' : 'רחוב (ערבית)') }}</label>
                    <input class="form-control" type="text" formControlName="company_address_str_ar" [(ngModel)]="CompanyAddressSTRAr" maxlength="100" />
                  </div>
                </div>
              </div>

              <div *ngIf="translationAddon.en" class="add-co-lang-block" dir="ltr">
                <div class="add-co-lang-block-head">
                  <span><span class="me-1">🇬🇧</span>English</span>
                  <button type="button" class="add-co-btn-remove-lang" (click)="removeTranslationLang('en')">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف' : 'הסר') }} ✕</button>
                </div>
                <div class="row">
                  <div class="mb-3 col-md-6">
                    <label class="form-label">Company name (English)</label>
                    <input class="form-control" type="text" formControlName="company_name_en" [(ngModel)]="companyNameEn" placeholder="e.g. ABC Ltd." />
                  </div>
                  <div class="mb-3 col-md-6">
                    <label class="form-label">City (English)</label>
                    <input class="form-control" type="text" formControlName="company_address_city_en" [(ngModel)]="CompanyAddressCityEn" maxlength="100" />
                  </div>
                  <div class="mb-3 col-12">
                    <label class="form-label">Street (English)</label>
                    <input class="form-control" type="text" formControlName="company_address_str_en" [(ngModel)]="CompanyAddressSTREn" maxlength="100" />
                  </div>
                </div>
              </div>

              <div class="add-co-add-lang-wrap" *ngIf="showAddTranslationButton">
                <div class="add-co-lang-picker">
                  <button type="button" class="add-co-btn-add-lang" (click)="toggleTranslationPicker()">
                    <i class="fa fa-plus"></i> {{ curentLang === 'en' ? 'Add language' : (curentLang === 'ar' ? 'أضف لغة' : 'הוסף שפה') }}
                  </button>
                  <div class="add-co-lang-dropdown" *ngIf="translationPickerOpen">
                    <button type="button" class="add-co-lang-option" *ngIf="!translationAddon.ar" (click)="addTranslationLang('ar')"><span class="me-1">🇸🇦</span> عربي</button>
                    <button type="button" class="add-co-lang-option" *ngIf="!translationAddon.en" (click)="addTranslationLang('en')"><span class="me-1">🇬🇧</span> English</button>
                  </div>
                </div>
              </div>
            </section>

            <div class="company-form-footer">
              <button type="button" class="btn company-btn-primary" (click)="updateCompanyById()">
                {{ curentLang === 'en' ? 'Update' : (curentLang === 'ar' ? 'تحديث' : 'עדכון') }}
                <i class="fa fa-check-circle ms-1"></i>
              </button>
              <a routerLink="/dashboard/companies" class="btn company-btn-secondary">
                {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }} ↩
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #templateModal let-modal>
    <div class="modal-header">
      <h6 class="modal-title">{{ curentLang === 'en' ? 'Template preview' : (curentLang === 'ar' ? 'معاينة القالب' : 'תצוגת תבנית') }}</h6>
      <button type="button" class="close btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body text-center">
      <h5 class="h6">{{ selectedTemplate?.name }}</h5>
      <img class="rounded img-fluid" alt="Template" [src]="selectedTemplate?.template_url" />
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-sm btn-danger" (click)="modal.close('Close click')">
        {{ curentLang === 'en' ? 'Close' : (curentLang === 'ar' ? 'إغلاق' : 'סגור') }}
        <i class="fa fa-rotate-left ms-1"></i>
      </button>
    </div>
  </ng-template>

  <!-- Admin: invoice sidebar (template/notes) + company form -->
  <div class="row g-4" *ngIf="user_type == 200 || user_type == 201">
    <div class="col-xl-4 d-flex flex-column gap-3" [formGroup]="updateCompanyInfo">
      <section class="company-form-section add-company-prototype">
        <div class="add-co-section-head">
          <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Images' : (curentLang === 'ar' ? 'الصور' : 'תמונות') }}</span>
        </div>
        <div class="add-co-upload-grid">
          <div class="add-co-upload-box uc-brand-upload" [class.has-image]="companyInfoData.logo_url"
               (click)="executeFunctions(companyInfoData?.company_id, uploadData)" role="button" tabindex="0">
            <div class="uc-brand-upload-inner">
              <img class="uc-brand-thumb" alt=""
                   [src]="companyInfoData.logo_url ? companyInfoData.logo_url : 'assets/default-logo/WhatsApp Image 2024-07-09 at 21.30.21_fc2afcbb.jpg'" />
              <div class="add-co-upload-icon uc-brand-cam"><i class="fa fa-camera"></i></div>
            </div>
            <div class="add-co-upload-label">{{ curentLang === 'en' ? 'Company logo' : (curentLang === 'ar' ? 'شعار المصلحة التجارية' : 'לוגו חברה') }}</div>
            <div class="add-co-upload-hint">{{ curentLang === 'en' ? 'Tap to change' : (curentLang === 'ar' ? 'اضغط للتغيير' : 'לחץ לשינוי') }}</div>
            <button type="button" class="add-co-remove-file mt-1" (click)="$event.stopPropagation(); getId(companyInfoData?.company_id); openVerticallyCentered(dataDeleted)">
              {{ curentLang === 'en' ? 'Remove logo' : (curentLang === 'ar' ? 'حذف الشعار' : 'מחק לוגו') }}
            </button>
          </div>
          <div class="add-co-upload-box uc-brand-upload" [class.has-image]="companyInfoData.seal_url"
               (click)="executeFunctionsSignatureModal(companyInfoData?.company_id, uploadSignature)" role="button" tabindex="0">
            <div class="uc-brand-upload-inner">
              <img class="uc-brand-thumb" alt=""
                   [src]="companyInfoData.seal_url ? companyInfoData.seal_url : 'assets/default-logo/WhatsApp Image 2024-07-09 at 21.30.21_fc2afcbb.jpg'" />
              <div class="add-co-upload-icon uc-brand-cam"><i class="fa fa-camera"></i></div>
            </div>
            <div class="add-co-upload-label">{{ curentLang === 'en' ? 'Seal / signature' : (curentLang === 'ar' ? 'التوقيع / الختم' : 'חתימה / חותמת') }}</div>
            <div class="add-co-upload-hint">{{ curentLang === 'en' ? 'Tap to change' : (curentLang === 'ar' ? 'اضغط للتغيير' : 'לחץ לשינוי') }}</div>
          </div>
        </div>
      </section>

      <section class="company-form-section add-company-prototype">
        <div class="add-co-section-head">
          <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Invoice appearance' : (curentLang === 'ar' ? 'مظهر الفاتورة' : 'מראה חשבונית') }}</span>
        </div>
        <div class="uc-template-thumb mb-3" (click)="openTemplateModal(templateModal)" role="button" tabindex="0">
          <img class="rounded w-100" style="max-height: 200px; object-fit: contain;" alt="Template"
               [src]="selectedTemplate?.template_url" />
        </div>
        <label class="form-label">{{ curentLang === 'en' ? 'Template' : (curentLang === 'ar' ? 'القالب' : 'תבנית') }}</label>
        <div *ngFor="let template of templates" class="form-check mb-1">
          <input type="radio" class="form-check-input" [id]="'tpl_ad_' + template.id"
                 [value]="template.id" formControlName="template_id"
                 (change)="onTemplateChange(template.id)"
                 [checked]="template.id === updateCompanyInfo.get('template_id')?.value" />
          <label class="form-check-label custom-radio-label" [for]="'tpl_ad_' + template.id"
                 [ngClass]="{'fw-semibold text-dark': updateCompanyInfo.get('template_id')?.value === template.id}">
            {{ curentLang === 'en' ? template.name_en : (curentLang === 'ar' ? template.name_ar : template.name_he) }}
          </label>
        </div>
        <div class="add-co-divider"></div>
        <div class="add-co-notes-grid row">
          <div class="mb-3 col-md-6">
            <div class="add-co-notes-col-title"><span class="add-co-dot add-co-dot-dark"></span>{{ curentLang === 'en' ? 'Right column note' : (curentLang === 'ar' ? 'ملاحظات يمين' : 'הערות ימין') }}</div>
            <textarea class="form-control add-co-input-optional" rows="3" maxlength="200" formControlName="right_note"
              [placeholder]="curentLang === 'en' ? 'e.g. Payment within 30 days.' : (curentLang === 'ar' ? 'مثال: الدفع خلال 30 يوماً.' : 'לדוגמה: תשלום בתוך 30 יום.')"
              [class.is-invalid]="updateCompanyInfo.get('right_note')?.invalid && updateCompanyInfo.get('right_note')?.touched"></textarea>
            <small class="text-muted d-block mt-1">{{ curentLang === 'en' ? 'Maximum 200 characters.' : (curentLang === 'ar' ? 'حد أقصى 200 حرفاً.' : 'עד 200 תווים.') }}</small>
          </div>
          <div class="mb-3 col-md-6">
            <div class="add-co-notes-col-title"><span class="add-co-dot add-co-dot-muted"></span>{{ curentLang === 'en' ? 'Left column note' : (curentLang === 'ar' ? 'ملاحظات يسار' : 'הערות שמאל') }}</div>
            <textarea class="form-control add-co-input-optional" rows="3" maxlength="200" formControlName="left_note"
              [placeholder]="curentLang === 'en' ? 'e.g. IBAN: IL00-0000-0000' : (curentLang === 'ar' ? 'مثال: IBAN: IL00-0000-0000' : 'לדוגמה: IBAN: IL00-0000-0000')"
              [class.is-invalid]="updateCompanyInfo.get('left_note')?.invalid && updateCompanyInfo.get('left_note')?.touched"></textarea>
            <small class="text-muted d-block mt-1">{{ curentLang === 'en' ? 'Maximum 200 characters.' : (curentLang === 'ar' ? 'حد أقصى 200 حرفاً.' : 'עד 200 תווים.') }}</small>
          </div>
        </div>
        <div class="add-co-invoice-preview-strip">
          <div class="add-co-preview-side" [class.empty]="!(updateCompanyInfo.get('right_note')?.value || '').toString().trim()">
            {{ (updateCompanyInfo.get('right_note')?.value || '').toString().trim() || (curentLang === 'en' ? 'Right note…' : (curentLang === 'ar' ? 'ملاحظات يمين...' : 'הערות ימין...')) }}
          </div>
          <div class="add-co-preview-center">{{ curentLang === 'en' ? '— Invoice preview —' : (curentLang === 'ar' ? '— معاينة الفاتورة —' : '— תצוגת חשבונית —') }}</div>
          <div class="add-co-preview-side" [class.empty]="!(updateCompanyInfo.get('left_note')?.value || '').toString().trim()">
            {{ (updateCompanyInfo.get('left_note')?.value || '').toString().trim() || (curentLang === 'en' ? 'Left note…' : (curentLang === 'ar' ? 'ملاحظات يسار...' : 'הערות שמאל...')) }}
          </div>
        </div>
      </section>
    </div>

    <div class="col-xl-8">
      <div class="card uc-main-card border-0 shadow-sm h-100">
        <div class="card-body">
          <form [formGroup]="updateCompanyInfoByAdmin" novalidate [ngClass]="{ 'was-validated': validate }" class="company-form-shell add-company-prototype">
            <section class="company-form-section">
              <div class="add-co-section-head">
                <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Basic details' : (curentLang === 'ar' ? 'البيانات الأساسية' : 'פרטים בסיסיים') }}</span>
                <span class="add-co-req-hint">{{ curentLang === 'en' ? '* Required field' : (curentLang === 'ar' ? '* حقل إلزامي' : '* שדה חובה') }}</span>
              </div>
              <div class="row">
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Company name (Hebrew)' : (curentLang === 'ar' ? 'اسم المصلحة التجارية (عبري)' : 'שם החברה (עברית)') }}<span class="text-danger">*</span></label>
                  <input class="form-control" onlyAlphabets required type="text" formControlName="company_name_he" [(ngModel)]="companyNamehE"
                    [placeholder]="curentLang === 'en' ? 'e.g. ABC Ltd.' : (curentLang === 'ar' ? 'مثال: مصلحة تجارية ABC المحدودة' : 'לדוגמה: חברת ABC בע״מ')" />
                  <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Please enter company name' : (curentLang === 'ar' ? 'الرجاء إدخال اسم المصلحة التجارية' : 'נא להזין את שם החברה') }}</div>
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Company type' : (curentLang === 'ar' ? 'نوع المصلحة التجارية' : 'סוג חברה') }}<span class="text-danger">*</span></label>
                  <ng-select formControlName="company_type_id" [searchable]="false" (change)="onCompanyTypeChange($event)"
                    [placeholder]="curentLang === 'en' ? 'Choose type…' : (curentLang === 'ar' ? 'اختر النوع…' : 'בחר סוג…')">
                    <ng-option *ngFor="let item of companyTypeData" [value]="item.company_type_id">
                      {{ curentLang === 'en' ? item.type_name_en : (curentLang === 'ar' ? item.type_name_ar : item.type_name_he) }}
                    </ng-option>
                  </ng-select>
                  <div *ngIf="updateCompanyInfoByAdmin.get('company_type_id')?.errors?.required" class="text-danger small mt-1">
                    {{ curentLang === 'en' ? 'Please choose company type' : (curentLang === 'ar' ? 'الرجاء اختيار نوع المصلحة التجارية' : 'אנא בחר סוג חברה') }}
                  </div>
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Tax ID / company no.' : (curentLang === 'ar' ? 'رقم المشغّل / ح.ف' : 'מספר עוסק / ח.פ') }}<span class="text-danger">*</span></label>
                  <input class="form-control" required type="text" [(ngModel)]="TaxRegister" (keypress)="isNumber($event)" maxlength="9" inputmode="numeric"
                    formControlName="tax_register" pattern="[0-9]{9}" />
                  <div *ngIf="updateCompanyInfoByAdmin.get('tax_register')?.invalid && (updateCompanyInfoByAdmin.get('tax_register')?.dirty || updateCompanyInfoByAdmin.get('tax_register')?.touched)" class="text-danger small">
                    {{ curentLang === 'en' ? 'Enter exactly 9 digits' : (curentLang === 'ar' ? 'يرجى إدخال 9 أرقام' : 'אנא הזן 9 ספרות') }}
                  </div>
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Phone' : (curentLang === 'ar' ? 'الهاتف' : 'טלפון') }}
                    <span class="text-muted fw-normal small">{{ curentLang === 'en' ? '(optional)' : (curentLang === 'ar' ? '(اختياري)' : '(אופציונלי)') }}</span></label>
                  <input class="form-control add-co-input-optional" type="tel" formControlName="company_phone" [(ngModel)]="companyPhone" placeholder="05X-XXXXXXX" />
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Commercial register' : (curentLang === 'ar' ? 'رقم السجل التجاري' : 'מספר רישום מסחרי') }}<span class="text-danger">*</span></label>
                  <input class="form-control" required type="text" formControlName="commercial_register" [(ngModel)]="CommercialRegister"
                    (keypress)="isNumber($event)" maxlength="9" inputmode="numeric" pattern="[0-9]{1,9}" />
                </div>
              </div>
            </section>

            <div class="add-co-divider"></div>

            <section class="company-form-section">
              <div class="add-co-section-head">
                <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Address' : (curentLang === 'ar' ? 'العنوان' : 'כתובת') }}</span>
              </div>
              <div class="row">
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'City (Hebrew)' : (curentLang === 'ar' ? 'المدينة (عبري)' : 'עיר (עברית)') }}<span class="text-danger">*</span></label>
                  <input class="form-control" onlyAlphabets required type="text" formControlName="company_address_city" [(ngModel)]="CompanyAddressCity" maxlength="100" />
                  <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Enter city' : (curentLang === 'ar' ? 'أدخل المدينة' : 'נא להזין עיר') }}</div>
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Street (Hebrew)' : (curentLang === 'ar' ? 'اسم الشارع (عبري)' : 'שם רחוב (עברית)') }}<span class="text-danger">*</span></label>
                  <input class="form-control" onlyAlphabets required type="text" formControlName="company_address_str" [(ngModel)]="CompanyAddressSTR" maxlength="100" />
                  <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Enter street' : (curentLang === 'ar' ? 'أدخل الشارع' : 'נא להזין רחוב') }}</div>
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Building no.' : (curentLang === 'ar' ? 'رقم المبنى' : 'מספר בניין') }}<span class="text-danger">*</span></label>
                  <input class="form-control" required type="number" formControlName="company_Building_number" [(ngModel)]="CompanyBuildingNumber" />
                  <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Enter building number' : (curentLang === 'ar' ? 'أدخل رقم المبنى' : 'נא להזין מספר בניין') }}</div>
                </div>
                <div class="mb-3 col-md-6">
                  <label class="form-label">{{ curentLang === 'en' ? 'Postal code' : (curentLang === 'ar' ? 'الرمز البريدي' : 'מיקוד') }}<span class="text-danger">*</span></label>
                  <input class="form-control" required type="number" formControlName="company_address_zip_code" [(ngModel)]="CompanyAddressZipCode" min="0" />
                  <div class="invalid-feedback text-danger">{{ curentLang === 'en' ? 'Enter postal code' : (curentLang === 'ar' ? 'أدخل الرمز البريدي' : 'נא להזין מיקוד') }}</div>
                </div>
              </div>
            </section>

            <div class="add-co-divider"></div>

            <section class="company-form-section">
              <div class="add-co-section-head">
                <span class="add-co-section-kicker">{{ curentLang === 'en' ? 'Translations' : (curentLang === 'ar' ? 'الترجمات' : 'תרגומים') }}</span>
              </div>

              <div *ngIf="translationAddon.ar" class="add-co-lang-block">
                <div class="add-co-lang-block-head">
                  <span><span class="me-1">🇸🇦</span>عربي</span>
                  <button type="button" class="add-co-btn-remove-lang" (click)="removeTranslationLang('ar')">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف' : 'הסר') }} ✕</button>
                </div>
                <div class="row">
                  <div class="mb-3 col-md-6">
                    <label class="form-label">{{ curentLang === 'en' ? 'Company name (Arabic)' : (curentLang === 'ar' ? 'اسم المصلحة التجارية (عربي)' : 'שם החברה (ערבית)') }}</label>
                    <input class="form-control" type="text" formControlName="company_name_ar" [(ngModel)]="companyNameAr" placeholder="مثال: مصلحة تجارية ABC المحدودة" />
                  </div>
                  <div class="mb-3 col-md-6">
                    <label class="form-label">{{ curentLang === 'en' ? 'City (Arabic)' : (curentLang === 'ar' ? 'المدينة (عربي)' : 'עיר (ערבית)') }}</label>
                    <input class="form-control" type="text" formControlName="company_address_city_ar" [(ngModel)]="CompanyAddressCityAr" maxlength="100" />
                  </div>
                  <div class="mb-3 col-12">
                    <label class="form-label">{{ curentLang === 'en' ? 'Street (Arabic)' : (curentLang === 'ar' ? 'اسم الشارع (عربي)' : 'רחוב (ערבית)') }}</label>
                    <input class="form-control" type="text" formControlName="company_address_str_ar" [(ngModel)]="CompanyAddressSTRAr" maxlength="100" />
                  </div>
                </div>
              </div>

              <div *ngIf="translationAddon.en" class="add-co-lang-block" dir="ltr">
                <div class="add-co-lang-block-head">
                  <span><span class="me-1">🇬🇧</span>English</span>
                  <button type="button" class="add-co-btn-remove-lang" (click)="removeTranslationLang('en')">{{ curentLang === 'en' ? 'Remove' : (curentLang === 'ar' ? 'حذف' : 'הסר') }} ✕</button>
                </div>
                <div class="row">
                  <div class="mb-3 col-md-6">
                    <label class="form-label">Company name (English)</label>
                    <input class="form-control" type="text" formControlName="company_name_en" [(ngModel)]="companyNameEn" placeholder="e.g. ABC Ltd." />
                  </div>
                  <div class="mb-3 col-md-6">
                    <label class="form-label">City (English)</label>
                    <input class="form-control" type="text" formControlName="company_address_city_en" [(ngModel)]="CompanyAddressCityEn" maxlength="100" />
                  </div>
                  <div class="mb-3 col-12">
                    <label class="form-label">Street (English)</label>
                    <input class="form-control" type="text" formControlName="company_address_str_en" [(ngModel)]="CompanyAddressSTREn" maxlength="100" />
                  </div>
                </div>
              </div>

              <div class="add-co-add-lang-wrap" *ngIf="showAddTranslationButton">
                <div class="add-co-lang-picker">
                  <button type="button" class="add-co-btn-add-lang" (click)="toggleTranslationPicker()">
                    <i class="fa fa-plus"></i> {{ curentLang === 'en' ? 'Add language' : (curentLang === 'ar' ? 'أضف لغة' : 'הוסף שפה') }}
                  </button>
                  <div class="add-co-lang-dropdown" *ngIf="translationPickerOpen">
                    <button type="button" class="add-co-lang-option" *ngIf="!translationAddon.ar" (click)="addTranslationLang('ar')"><span class="me-1">🇸🇦</span> عربي</button>
                    <button type="button" class="add-co-lang-option" *ngIf="!translationAddon.en" (click)="addTranslationLang('en')"><span class="me-1">🇬🇧</span> English</button>
                  </div>
                </div>
              </div>
            </section>

            <div class="company-form-footer">
              <button type="button" class="btn company-btn-primary" (click)="updateCompanyByAdminByCompanyId()">
                {{ curentLang === 'en' ? 'Update' : (curentLang === 'ar' ? 'تحديث' : 'עדכון') }}
                <i class="fa fa-check-circle ms-1"></i>
              </button>
              <a routerLink="/dashboard/companies" class="btn company-btn-secondary">
                {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? 'رجوع' : 'חזרה') }} ↩
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  </div>

  <!-- upload image -->

  <ng-template #uploadData let-modal>
	<div class="modal-header">
	<h6 class="modal-title" style="color: grey;">
        {{ curentLang === 'en' ? 'Update logo' : (curentLang === 'ar' ? 'تعديل الشعار' : 'עדכון לוגו') }}
    </h6>
	<button type="button" class="close btn-close" style="color: grey;" aria-label="Close" (click)="modal.dismiss('Cross click')">
	   
	</button>

	</div>
	<div class="modal-body my-2">
   
	  <div class="product-image text-center">
        <img *ngIf="currentImageUrl" [src]="currentImageUrl" alt="" class="my-2">
        <input type="file" class="form-control form-control-sm"  (change)="onFileChanged($event)" [accept]="'image/*'">
      </div>
      
      			
	</div>
    <div class="modal-footer">

        <button type="button" 
         class="btn btn-sm m-auto mt-2" 
        style="background-color: #141414; color: #fff;"
        (click)="uploadFile()"
         > 
          {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? '  تاكيد ' : '  אישור  ') }}
          <i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
      </button>
  
          <button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
              {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? '  رجوع ' : '  חזרה  ') }}
              <i class="fa fa-rotate-left mx-1"></i>
          </button>
  
        
  
      </div>
  </ng-template>

   <!-- upload signature-->

   <ng-template #uploadSignature let-modal>
    <div class="modal-header">
    <h6 class="modal-title" style="color: grey;">
          {{ curentLang === 'en' ? 'Update seal / signature' : (curentLang === 'ar' ? 'تعديل الختم / التوقيع' : 'עדכון חותמת / חתימה') }}
      </h6>
    <button type="button" class="close btn-close" style="color: grey;" aria-label="Close" (click)="modal.dismiss('Cross click')">
    </button>
  
    </div>
    <div class="modal-body my-2">
     
      <div class="product-image text-center">
          <img *ngIf="currentImageUrl" [src]="currentImageUrl" alt="" class="my-2">
          <input type="file" class="form-control form-control-sm"  (change)="onFileChanged($event)" [accept]="'image/*'">
        </div>
        
              
    </div>
      <div class="modal-footer">
  
          <button type="button" 
           class="btn btn-sm m-auto mt-2" 
          style="background-color: #141414; color: #fff;"
          (click)="uploadSeal()"
           > 
            {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? '  تاكيد ' : '  אישור  ') }}
            <i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
        </button>
    
            <button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
                {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? '  رجوع ' : '  חזרה  ') }}
                <i class="fa fa-rotate-left mx-1"></i>
            </button>
    
          
    
        </div>
    </ng-template>



     <!--Delete image-->

     <ng-template #dataDeleted let-modal>
      <div class="modal-header">
          <h4 class="modal-title"></h4>
          <button type="button" class="close btn-close"  style="color: grey;"  aria-label="Close" (click)="modal.dismiss('Cross click')">
               
          </button>
      </div>
      <div class="modal-body">
          <p class="text-center text-danger"> <i class="fa fa-trash text-danger"></i>
            {{curentLang === 'en' ? 'Are you sure you want to delete it?' : (curentLang === 'ar' ? '  هل تريد بالتأكيد حذفه؟ ' : ' هل تريد بالتأكيد حذفه؟') }}
          </p>
      </div>
      <div class="modal-footer">
  
        <button type="button" 
         class="btn btn-sm m-auto mt-2" 
        style="background-color: #141414; color: #fff;"
         (click)="deleteCompanyLogoByCompanyId()"
         > 
          {{ curentLang === 'en' ? 'Confirm' : (curentLang === 'ar' ? '  تاكيد ' : '  אישור  ') }}
          <i class="fa fa-check-circle mx-1" style="color: #fff;"></i>
      </button>
  
          <button type="button" class="btn btn-sm m-auto mt-2 btn-danger" (click)="modal.close('Close click')">
              {{ curentLang === 'en' ? 'Back' : (curentLang === 'ar' ? '  رجوع ' : '  חזרה  ') }}
              <i class="fa fa-rotate-left mx-1"></i>
          </button>
  
        
  
      </div>
  </ng-template>

</div>
